export default __webpack_public_path__ + "assets/49e3f006018662f60f1db2aec0b2cca9.png";